<template>
    <el-row :gutter="20">
        <el-col :span="24">
            <ul class="contactBottom">
                <li>
                    <h3>{{ $t('contactUs.question') }}</h3>
                    <p>
                        {{ $t('contactUs.contactUs') }}
                    </p>
                    <a class="contactUsBtn btn-blue" href="https://autopay.eu/kontakt">{{ $t('contactUs.contactUsBtn') }}</a>
                </li>
                <li>
                    <div>
                        <p class="phone">
                            <a href="tel:585008005">58 500 80 05</a>
                            <a href="tel:587604844">58 760 48 44</a>
                        </p>
                        <p class="hours">
                            {{ $t('weekDays.mo') }} - {{ $t('weekDays.fr') }}  8.00 - 16.00
                        </p>
                    </div>
                </li>
            </ul>
        </el-col>
    </el-row>
</template>

<script>
export default {
  name: 'LayoutContact'
}
</script>
